export default __webpack_public_path__ + "static/media/badges-blue-icon.9e457fbd.svg";